import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

import { EntityLink, EntityLinkProps } from './EntityLink';


export interface RelatedEntityProps {
  label: string;
  link: EntityLinkProps;
}

export const RelatedEntity = (props: RelatedEntityProps) => {
  if (props.link) {
    return (
      <>
        <dt className={DetailsTooltipStyles.DescriptionTerm}>{props.label}</dt>
        <dd className={DetailsTooltipStyles.DescriptionDetails}><EntityLink {...props.link} /></dd>
      </>
    );
  } else {
    return null;
  }
};
